import Backbone from 'backbone'
import 'backbone-associations'
import 'backbone.computedfields'
import Item from './item'
import items from '../items'
import productChannel from '../productChannel'

// Product is basically a (state model) instance of an item.
// It has a reference to the item (data) model under `item`
let Product
export default Product = (function () {
  Product = class Product extends Backbone.AssociatedModel {
    static initClass() {
      this.prototype.relations = [
        {
          type: Backbone.One,
          key: 'item',
          relatedModel: Item
        },
        {
          type: Backbone.One,
          key: 'substrate',
          relatedModel: Product
        },
        {
          type: Backbone.One,
          key: 'trim',
          relatedModel: Product
        }
      ]

      this.prototype.defaults = { quantity: 0 }

      this.prototype.computed = {
        subtotalSingle: {
          depends: ['quantity', 'item'],
          get(fields) {
            return (
              fields.quantity *
                fields.item.getPriceAtQuantity(fields.quantity) || 0
            )
          }
        },
        subtotalSingleWithAddOns: {
          depends: ['subtotalSingle', 'substrate', 'trim'],
          get(fields) {
            const mainSubtotal = fields.subtotalSingle
            const substrateSubtotal =
              (fields.substrate != null
                ? fields.substrate.get('subtotalSingle')
                : undefined) || 0
            const trimSubtotal =
              (fields['trim'] != null
                ? fields['trim'].get('subtotalSingle')
                : undefined) || 0
            return mainSubtotal + substrateSubtotal + trimSubtotal
          }
        },
        subtotal: {
          depends: ['subtotalSingleWithAddOns'],
          get(fields) {
            return fields.subtotalSingleWithAddOns
          }
        }
      }
    }

    initialize() {
      this.set('item', items.getItem(this.id))

      this.computedFields = new Backbone.ComputedFields(this)
      return this.listenTo(this, 'change', this.notifyChannel)
    }

    notifyChannel() {
      // Only notify the channel if the trim, quantity, or substrate changed (i.e. if the
      // property is in the changed object, even if its value is undefined).
      if (
        'quantity' in this.changed ||
        'trim' in this.changed ||
        'substrateEnumName' in this.changed
      ) {
        productChannel.trigger('optionChanged', {
          ...('quantity' in this.changed && {
            quantity: this.changed.quantity
          }),
          ...('trim' in this.changed && {
            trim: this.changed.trim
          }),
          ...('substrateEnumName' in this.changed && {
            substrateEnumName: this.changed.substrateEnumName
          })
        })
      }
    }
  }
  Product.initClass()
  return Product
})()
